module.exports = __webpack_public_path__ + "img/logo-white-type.688d4d97.png";